import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { ProtocolAnswerInDto } from 'shared/dtos/in/protocolAnswer';
import { inspectionContract } from 'shared/domain/inspection/inspectionContract';
import { makeErrorPublisher, makeEventPublisher } from 'serviceWorker/broadcasts/publishers';

const publishInspectionError = makeErrorPublisher(inspectionContract);

const broadcastProtocolAnswerError = (error: unknown, uniqueId?: string): void =>
  publishInspectionError(DomainMessagesTypes.failUploadedEntity, error, { uniqueId });

export const broadcastUpdatedProtocolAnswer = makeEventPublisher(inspectionContract, DomainMessagesTypes.updatedEntity);

export const broadcastUpdatedProtocolAnswerError = (
  error: unknown,
  uniqueId?: string
): void => {
  broadcastProtocolAnswerError(error, uniqueId);
};

export const broadcastUpdatedProtocolSectionAnswersBatch =
  makeEventPublisher(inspectionContract, DomainMessagesTypes.updatedEntity);

export const broadcastUpdatedProtocolSectionAnswersBatchError = (
  error: unknown,
  uniqueId?: string
): void => {
  broadcastProtocolAnswerError(error, uniqueId);
};
